import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'isActionable', standalone: true, pure: true})
export class IsActionablePipe implements PipeTransform {
  transform(content: any): boolean {
    return Array.isArray(content?.followUpActions) && content.followUpActions.length > 0;
  }
}
